import { addModal } from 'weblite-web-modal-viewer'
import { SendVoiceDialog } from './send-voice-dialog'

const COMPONENT_ID = 'sendVoiceDialog'

export const showSendVoiceDialog = (
  props: Parameters<typeof SendVoiceDialog>[0],
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: SendVoiceDialog,
  },
}
